import { createAction } from '@reduxjs/toolkit';

import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

// EDIT EMAIL FLOW STEPS
export const VERIFY_MFA = 'verify-mfa';
export const CHANGE_EMAIL = 'change-email';
export const EDIT_EMAIL_STEPS = [VERIFY_MFA, CHANGE_EMAIL];

export const EDIT_EMAIL_STEPS_TO_NUMBERS_MAP = {
    [VERIFY_MFA]: 1,
    [CHANGE_EMAIL]: 2,
};

// EDIT EMAIL FLOW ACTIONS
export const editEmailSetSteps = createAction('EDIT_EMAIL_STEPS::SET_STEP');

const useEditEmail = () => {
    const steps = useSteps(EDIT_EMAIL_STEPS, VERIFY_MFA);

    useActionObservableCallback(hookAction$, editEmailSetSteps().type, (step) =>
        steps.setStep(step),
    );

    return {
        ...steps,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useEditEmail();

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [EditEmailProvider, useEditEmailContext] =
    createContextProvider(providerFactory);
